var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-muted"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin mr-1"}),_vm._v(" "+_vm._s(_vm.text)+"… ")])
}
var staticRenderFns = []

export { render, staticRenderFns }